module.exports = __webpack_public_path__ + "img/6.80bf73be.png";